import { ErrorType } from 'src/shared/lib/response-worker/model'

export interface ShowError {
    showMessage: string
    errorType?: ErrorType
}
export const isShowMessage = (err: unknown): err is ShowError => !!(err as ShowError).showMessage
